/* eslint-disable max-len */
import React from 'react';
import { SvgProps, IconType } from '../../types/types';

export const Peakairplay: IconType = (props: SvgProps) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25 41H10.1131C7.82236 41 6.37681 38.5362 7.49429 36.5365L21.4151 11.6257C22.5527 9.58998 25.4761 9.57371 26.6363 11.5966L40.9234 36.5075C42.0705 38.5075 40.6266 41 38.321 41H32"
        stroke="#7D7FE8"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M15 23L17.7315 25.7315C18.1452 26.1452 18.8241 26.117 19.202 25.6704L22.9798 21.2057C23.4539 20.6454 24.3499 20.7697 24.6536 21.4378L25.6912 23.7206C26.0286 24.463 27.0651 24.511 27.4698 23.8029L30.5 18.5"
        stroke="#7D7FE8"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M23.0058 39.3245L23.0689 32.5474C23.0718 32.2377 23.283 31.9689 23.5832 31.8928L34.1509 29.2152C34.5817 29.106 35.0002 29.4317 35.0002 29.8761V40.5839C35.0002 44.1094 32.5365 44.1633 31.2054 44.1094C28.6521 44.0061 28.3969 39.9948 31.4246 39.1211C31.7489 39.0276 32.0029 38.7503 32.0065 38.4128L32.0521 34.1757C32.057 33.7221 31.6259 33.3903 31.1887 33.5112L26.8125 34.7211C26.5268 34.8001 26.3248 35.0546 26.3129 35.3508L26.0002 43.1021C26.0002 45.3685 22.2054 46 20.8035 44.8649C19.1426 43.2415 19.8593 40.4822 22.3259 40.056C22.6945 39.9923 23.0023 39.6986 23.0058 39.3245Z"
        fill="white"
        stroke="#7D7FE8"
        strokeWidth="2.04545"
      />
      <path
        d="M28 7.5L27.8624 7.44838C25.3721 6.51455 22.6279 6.51454 20.1376 7.44838L20 7.5"
        stroke="#6668C4"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M27 4V4C25.0527 3.35089 22.9473 3.35089 21 4V4"
        stroke="#B1B2F1"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
